<template>
  <VDropdown :delay="0" :triggers="['click']" placement="top">
    <slot>
      <button class="btn btn-ghost btn-square">
        <i class="iconify mdi--dots-vertical" />
      </button>
    </slot>
    <template #popper>
      <ul
        class="menu menu-sm rounded-box w-52 p-2 text-base-content bg-transparent"
      >
        <li>
          <label
            class="w-full cursor-pointer hover:bg-base-200 rounded px-4 py-2"
            @click="$emit('upload-image')"
          >
            导入图片
          </label>
        </li>
        <li>
          <label
            class="w-full cursor-pointer hover:bg-base-200 rounded-lg px-4 py-2"
            @click="$emit('export-png')"
          >
            导出绘画
          </label>
        </li>
        <!-- <li>
          <a
            class="flex items-center gap-2 text-error"
            @click="$emit('clear-all')"
          >
            清空图层
          </a>
        </li> -->
      </ul>
    </template>
  </VDropdown>
</template>

<script setup lang="ts">
// Emits definition
defineEmits<{
  (e: "export"): void;
  (e: "export-png"): void;
  (e: "import", event: Event): void;
  (e: "upload-image"): void;
  (e: "merge-colors"): void;
  (e: "remove-noise"): void;
  (e: "auto-fill"): void;
  (e: "clear-all"): void;
}>();
</script>

<style scoped>
/* Menu button height adjustment */
.btn {
  min-height: 2rem;
  height: 2rem;
}

/* Ensure proper dropdown spacing */
.dropdown-content {
  margin-top: 0.25rem;
}
</style>
